import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal, Alert, Button } from '@grandvisionhq/common';
import { Heading, Hr } from '@grandvisionhq/elements';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const PauseSubscriptionModal = ({ className , pauseDurationOptions , onCancel , onPause , isLoading , errorMessage ,  })=>{
    const intl = useIntl();
    const [selection, setSelection] = React.useState(pauseDurationOptions[0]);
    const formattedDurations = React.useMemo(()=>pauseDurationOptions.reduce((acc, option)=>{
            const durationLabelKey = option.amount === 1 ? option.unit.slice(0, -1) : option.unit;
            const durationLabel = `${option.amount} ${intl.getLabel(`common.duration.${durationLabelKey.toLowerCase()}`)}`;
            return swcHelpers.objectSpread({}, acc, {
                [durationLabel]: option
            });
        }, {})
    , [
        intl,
        pauseDurationOptions
    ]);
    const onSelectChange = React.useCallback((duration)=>{
        setSelection(duration);
    }, []);
    const handlePause = React.useCallback(()=>{
        if (selection) {
            onPause(selection);
        }
    }, [
        onPause,
        selection
    ]);
    const buttonCaption = isLoading ? intl.getLabel('common.loadingText') : intl.getLabel('account.pauseSubscription.actions.pause');
    return /*#__PURE__*/ React.createElement(Modal, {
        showIcon: true,
        isOpen: true,
        onModalClose: onCancel,
        "aria-label": intl.getLabel('account.pauseSubscription.title'),
        className: classnames('pause-subscription', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "pause-subscription__title"
    }, intl.getLabel('account.pauseSubscription.title')), /*#__PURE__*/ React.createElement(Hr, null), /*#__PURE__*/ React.createElement("p", {
        className: "pause-subscription__description"
    }, intl.getLabel('account.pauseSubscription.description')), /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: intl.getFormattedLabel('account.pauseSubscription.info', {
            parseLink: true
        })
    }), errorMessage && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "warning",
        message: errorMessage
    }), /*#__PURE__*/ React.createElement(Select, {
        id: "pause-duration-select",
        name: "pause-duration-select",
        className: "pause-subscription__select",
        options: formattedDurations,
        onChange: onSelectChange,
        label: intl.getLabel('account.pauseSubscription.select.label')
    }), /*#__PURE__*/ React.createElement("div", {
        className: "pause-subscription__buttons"
    }, /*#__PURE__*/ React.createElement(Button, {
        caption: buttonCaption,
        className: "pause-subscription__button",
        "data-t": "pause-subscription-modal-confirm",
        onClick: handlePause,
        disabled: isLoading
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: intl.getLabel('common.actions.cancel'),
        className: "pause-subscription__button",
        "data-t": "pause-subscription-modal-cancel",
        onClick: onCancel,
        variant: "outline"
    })));
};
var PauseSubscriptionModal$1 = PauseSubscriptionModal;

export { PauseSubscriptionModal$1 as default };
//# sourceMappingURL=PauseSubscription.js.map
